import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable} from 'rxjs';
import { RepaymentEstimationEntry } from '@portal-workspace/grow-shared-library';
import { LooseCurrencyPipe } from '../../pipes/loose-currency.pipe';
import { MatTableModule } from '@angular/material/table';

export class RepaymentEstimationComponentDataSource extends DataSource<RepaymentEstimationEntry>{

  subject = new BehaviorSubject<RepaymentEstimationEntry[]>([]);

  connect(collectionViewer: CollectionViewer): Observable<RepaymentEstimationEntry[]> {
    return this.subject;
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.subject.complete();
  }

  update(d: RepaymentEstimationEntry[]) {
    this.subject.next(d);
  }
}


@Component({
    selector: 'repayment-estimation',
    templateUrl: './repayment-estimation.component.html',
    styleUrls: ['./repayment-estimation.component.scss'],
    standalone: true,
    imports: [MatTableModule, LooseCurrencyPipe]
})
export class RepaymentEstimationComponent implements OnInit, OnChanges {

  @Input({required: false}) data: RepaymentEstimationEntry[] = [];

  dataSource = new RepaymentEstimationComponentDataSource();

  ngOnInit(): void {
    this.dataSource.update(this.data);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.update(this.data);
  }

  sanitise(amount: any) {
    if (amount && String(amount).startsWith('$')) {
      return String(amount).substr(1);
    }
    return amount;
  }

}
